import axios from "axios";
import { Promise } from "q";
import { API_URL, STATUS_OK } from "./../../../../config";

export default class NoteModalService {
    static createNote = (id, note, username, token) => {
        return new Promise((resolve, reject) => {
          axios
            .post(
              `${API_URL}users/${username}/bookmarks/${id}/note`,
              {
                note: note,
              },
              {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
              }, 
            })
            .then(response => {
              if (response.status === STATUS_OK) resolve(response.data);
              else reject(response);
            })
            .catch(error => {
              reject(error);
            });
        });
    }
    
    static deleteNote = (id, username, token) => {
        return new Promise((resolve, reject) => {
            axios
            .delete(`${API_URL}users/${username}/bookmarks/${id}/note`,{
            headers: {
                Authorization: `Bearer ${token}`
            },
            })
            .then(response => {
            if (response.status === STATUS_OK) resolve(response.data);
            else reject(response);
            })
            .catch(error=>{
            reject(error);
            });
        });
    }
}